/** Shared setup rules: absence is unknown, zero is a valid declared quantity. */
export const communalAreaTypes = ['Car park', 'Garden or grounds', 'Communal lounge', 'Reception or concierge area', 'Bin store', 'Cycle store', 'Parcel room', 'Meter or plant room', 'Roof terrace', 'Gym or leisure facility', 'Playground', 'None', 'Other'];
export function buildingSetupErrors(value) {
    const errors = {};
    for (const [key, label, min, max] of [['name', 'building name', 2, 180], ['line1', 'address', 1, 180], ['townCity', 'town or city', 1, 120], ['postcode', 'postcode', 2, 20]]) {
        if (typeof value[key] !== 'string' || value[key].trim().length < min)
            errors[key] = `Enter the ${label}.`;
        else if (value[key].trim().length > max)
            errors[key] = `Use no more than ${max} characters.`;
    }
    for (const [key, max] of [['expectedResidentialUnits', 10000], ['expectedCommercialUnits', 10000], ['storeys', 300], ['heightMetres', 1000]]) {
        const n = value[key];
        if (n === undefined && key !== 'expectedResidentialUnits')
            continue;
        if (typeof n !== 'number' || !Number.isFinite(n) || n < 0 || n > max || (key !== 'heightMetres' && !Number.isInteger(n)))
            errors[key] = key === 'heightMetres' ? `Enter a number from 0 to ${max}.` : `Enter a whole number from 0 to ${max}.`;
    }
    if (value.commercialUnitStatus === 'Yes' && !(Number(value.expectedCommercialUnits) > 0))
        errors.expectedCommercialUnits = 'Enter the number of commercial units, or choose No when there are none.';
    if (!['Yes', 'No', 'To confirm'].includes(String(value.commercialUnitStatus)))
        errors.commercialUnitStatus = 'Choose whether the building has commercial units.';
    if (value.managementEndDate && value.managementStartDate && String(value.managementEndDate) < String(value.managementStartDate))
        errors.managementEndDate = 'The end date must not be before the start date.';
    for (const key of ['managementStartDate', 'managementEndDate'])
        if (value[key] && (!/^\d{4}-\d{2}-\d{2}$/.test(String(value[key])) || !Number.isFinite(Date.parse(String(value[key]))) || new Date(String(value[key])).toISOString().slice(0, 10) !== value[key]))
            errors[key] = 'Enter a valid date.';
    if (Array.isArray(value.initialAssets))
        for (const item of value.initialAssets) {
            if (item && item.quantityStatus === 'Known' && (!Number.isInteger(item.quantity) || item.quantity <= 0 || item.quantity > 10000))
                errors[`feature-quantity-${item.code}`] = 'Enter a whole number greater than zero for a present asset, or leave its quantity to confirm.';
        }
    if (value.communalAreas !== undefined) {
        const areas = value.communalAreas;
        if (!Array.isArray(areas) || areas.some(a => !communalAreaTypes.includes(a)) || new Set(areas).size !== areas.length)
            errors.communalAreas = 'Choose the communal areas from the list.';
        else if (areas.includes('None') && areas.length > 1)
            errors.communalAreas = 'Choose None on its own.';
        else if (areas.includes('Other') && (typeof value.communalAreaOther !== 'string' || !value.communalAreaOther.trim()))
            errors.communalAreaOther = 'Describe the other communal area.';
        if (typeof value.communalAreaOther === 'string' && value.communalAreaOther.length > 500)
            errors.communalAreaOther = 'Use no more than 500 characters.';
    }
    return errors;
}
//# sourceMappingURL=building-setup.js.map